import clsx from 'clsx'

import Text, { TextColor } from '@/components/view/atoms/text/Text'

const priorityStyle = (priority: 'high' | 'medium' | 'low') => {
  switch (priority) {
    case 'high':
      return {
        strip: 'bg-fill-critical',
        stripText: TextColor.ON_BG_FILL,
        label: '高'
      }
    case 'medium':
      return {
        strip: 'bg-primitive-kaki-300',
        stripText: TextColor.PRIMARY,
        label: '中'
      }
    default:
      return {
        strip: 'bg-sumi-300',
        stripText: TextColor.PRIMARY,
        label: '低'
      }
  }
}

interface Props {
  priority: 'high' | 'medium' | 'low'
  size?: 'normal' | 'big'
}

const PriorityBadge = ({ priority, size = 'normal' }: Props) => {
  return (
    <div
      className={clsx(
        'flex shrink-0 items-center justify-center gap-0.5',
        size == 'normal' ? 'rounded-lg p-1' : 'w-12 flex-col rounded-l-lg px-1 py-2',
        priorityStyle(priority).strip
      )}
    >
      <Text
        size={12}
        color={priorityStyle(priority).stripText}
        weight={size == 'normal' && priority == 'medium' ? 'bold' : 'normal'}
      >
        {size == 'normal' ? '優先度:' : '優先度'}
      </Text>
      <Text
        size={size == 'normal' ? 12 : 16}
        weight={size == 'big' || priority == 'medium' ? 'bold' : 'normal'}
        color={priorityStyle(priority).stripText}
      >
        {priorityStyle(priority).label}
      </Text>
    </div>
  )
}

export default PriorityBadge
